export default function (http) {
    return {
        queryByPage (data){
            return http.json({
                url: '/sys/operationLog/query',
                data
            });
        },

        queryLogPage (data){
            return http.json({
                url: '/sys/url/log/query',
                data
            });
        },


        delete (data){
            return http.json({
                url: '/sys/message/delete',
                data
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/logs.js